export default __webpack_public_path__ + "static/media/radio.69953d74.svg";